import React, {useState, useEffect} from 'react'
import { Form, InputGroup, Button, Row, Col, Dropdown } from 'react-bootstrap'
import Select from 'react-select'
import { useTranslation } from 'react-i18next';
import { customerService, roleService, userService, licenseService } from '../../_services'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faKey, faTrash, faPlus } from '@fortawesome/free-solid-svg-icons'

const UserForm = ({data, handleChange, handleSubmit, validated}) => {
    const [customers, setCustomers] = useState([])
    const [userLicenses, setUserLicenses] = useState([])
    const [userRoles, setUserRoles] = useState([])
//    const [roles, setRoles] = useState([])
//    const [selectedRoles, setSelectedRoles] = useState([])
    const [users, setUsers] = useState([])

    const {t} = useTranslation('common');

    useEffect(() => {
        customerService.getOptions().then(customers => {
            customers.sort((a, b) => a.name.localeCompare(b.name))
            setCustomers(customers)
            if (data.customer === -1 && customers.length > 0) {
                handleChange({target: {type: "select", name: "customer", value: customers[0].id}})
            }
        })
        licenseService.simpleList().then(licenses => {
            var userLicenses = []
            var selectedUserLicenses = []
            licenses.forEach(license => {
                console.log(license)
                var userLicense = data.userLicenses.find(userLicense => userLicense.license == license.id)
                if (userLicense) {
                    userLicense.name = license.name
					userLicense.licenseCode = license.licenseCode
					userLicense.customerId = license.customerId
					selectedUserLicenses.push(userLicense)
                } else {
					userLicense = {
						license: license.id,
						name: license.name,
						licenseCode: license.licenseCode,
						customerId: license.customerId
					}
                }
                userLicenses.push(userLicense)
            })
            setUserLicenses(userLicenses)
        })
        roleService.list().then(roles => {
            var userRoles = roles.map(role => {
                return {'user': -1, 'role': role.id, 'roleAuthority': role.authority}
            })
            setUserRoles(userRoles)
        })
        userService.list().then(users => {
            users.sort((a, b) => a.username.localeCompare(b.username))
            setUsers(users)
        })
    }, [])

    function onCustomerChange(e) {
        console.log(e)
        handleChange({target: {type: "select", name: "customer", value: e.id}})
    }

    function onParentChange(e) {
        console.log(e)
        if (e) {
            handleChange({target: {type: "select", name: "parent", value: e.id}})
        } else {
            handleChange({target: {type: "select", name: "parent", value: null}})
        }
    }

    function onRoleChange(e) {
        //Example: [{id: 10, authority: "ROLE_DEVICE_READ"}]
        if (e) {
            //setSelectedRoles(e)
            handleChange({target: {type: "select", name: "userRoles", value: e}})
        } else {
            //setSelectedRoles([])
            handleChange({target: {type: "select", name: "userRoles", value: []}})
        }
    }

    function onUserLicenseChange(e) {
        handleChange({target: {type: "select", name: "userLicenses", value: e || []}})
    }

    const handleUserChange = (user) => {
        if (user) {
            console.log(user.userRoles)
            var newSelectedValues = []
            user.userRoles.forEach(userRole => {
                newSelectedValues.push({user: -1, role: userRole.role, roleAuthority: userRole.roleAuthority})
            })
            console.log(newSelectedValues)
            //setSelectedRoles(newSelectedValues)
            handleChange({target: {type: "select", name: "userRoles", value: newSelectedValues}})
        }
    }

    const filterUserLicenses = () => {
		return userLicenses.filter(userLicense => userLicense.customerId == data.customer)
    }

    const generatePassword = () => {
        let validChars = "ABCDEFGHJKLMNPQRSTUVXYZabcdefghijkmnopqrstuvxyz23456789"
        var newPassword = ""
        for (var i = 0; i < 12; i++) {
            let index = Math.floor(Math.random() * validChars.length)
            newPassword += validChars.charAt(index)
        }
        handleChange({target: {type: "input", name: "password", value: newPassword}})
    }

    const onChangeParamKey = (e, key) => {
        var newKey = e.target.value
		var newParams = {...data.params}
		newParams[newKey] = newParams[key]
		delete newParams[key]
		handleChange({target: {type: "object", name: "params", value: newParams}})
    }

    const onChangeParamValue = (e, key) => {
		var newParams = {...data.params}
		newParams[key] = e.target.value
		handleChange({target: {type: "object", name: "params", value: newParams}})
    }

    const removeParam = key => {
		var newParams = {...data.params}
		delete newParams[key]
		handleChange({target: {type: "object", name: "params", value: newParams}})
    }

    const addParam = () => {
        var newParams = {...data.params}
		newParams[''] = ''
		handleChange({target: {type: "object", name: "params", value: newParams}})
    }

    const getMailTo = (language) => {
        var firstName = ""
        if (data.fullName) {
            firstName = " " + data.fullName.split(" ")[0]
        }
        var password = data.password
        if (password.includes('{bcrypt}')) {
            password = ''
        }
        if (language == "SV") {
            return "mailto:" + data.email + "?subject=Telcodox användaruppgifter&body=" + "Hej" + firstName + "," + "%0D%0A" +
				"%0D%0A" +
				"Vi har skapat ett konto till dig på https://telcodox.iqmtel.net/" + "%0D%0A" +
				"Användarnamn: " + data.username + "%0D%0A" +
				"Lösenord: " + password + "%0D%0A" +
				"%0D%0A" +
				"Mvh Kristofer" + "%0D%0A" +
				"IQMTEL Sweden AB"
        }
        return "mailto:" + data.email + "?subject=Telcodox account info&body=" + "Hi" + firstName + "," + "%0D%0A" +
			"%0D%0A" +
			"We have created an account for you at https://telcodox.iqmtel.net/" + "%0D%0A" +
			"Username: " + data.username + "%0D%0A" +
			"Password: " + password + "%0D%0A" +
			"%0D%0A" +
			"Regards," + "%0D%0A" +
			"Kristofer" + "%0D%0A" +
			"IQMTEL Sweden AB"
    }

    return (
        <Form id="data-form" noValidate onSubmit={handleSubmit} validated={validated}>
            <Row>
                <Col sm="6">
		            <Form.Group controlId="customer">
		                <Form.Label>
		                    {t('user.columns.customer')} *
		                </Form.Label>
		                <Select
		                    placeholder={t('user.columns.customer')}
		                    isLoading={customers.length === 0}
		                    options={customers}
		                    value={customers.find(customer => customer.id === data.customer)}
		                    getOptionLabel={customer => customer.name}
		                    getOptionValue={customer => customer.id}
		                    onChange={onCustomerChange}
		                />
		            </Form.Group>
		            <Form.Group controlId="parent">
		                <Form.Label>
		                    {t('user.columns.parent')}
		                </Form.Label>
		                <Select
		                    placeholder={t('user.columns.parent')}
		                    isLoading={users.length === 0}
		                    isClearable={true}
		                    options={users.filter(user => user.id != data.id)}
		                    value={users.find(user => user.id === data.parent)}
		                    getOptionLabel={user => user.username + " (" + user.customerName + ")"}
		                    getOptionValue={user => user.id}
		                    onChange={onParentChange}
		                />
		            </Form.Group>
		            <Form.Group controlId="username">
		                <Form.Label>
		                    {t('user.columns.username')} *
		                </Form.Label>
		                <Form.Control required type="text" placeholder={t('user.columns.username')} name="username" value={data.username} onChange={handleChange}/>
		            </Form.Group>
		            <Form.Group controlId="password">
		                <Form.Label>
		                    {t('user.columns.password')} *
		                </Form.Label>
		                <InputGroup>
			                <Form.Control required type="input" placeholder={t('user.columns.password')} name="password" value={data.password} onChange={handleChange} autoComplete="new-password"/>
			                <Button variant="outline-primary" onClick={generatePassword}>
			                    <FontAwesomeIcon icon={faKey}/>
			                </Button>
		                </InputGroup>
		            </Form.Group>
		            <Form.Group controlId="email">
		                <Form.Label>
		                    {t('user.columns.email')} {data.twoFactorAuthentication ? '*' : ''}
		                </Form.Label>
		                <Form.Control required={data.twoFactorAuthentication} type="email" placeholder={t('user.columns.email')} name="email" value={data.email || ''} onChange={handleChange}/>
		            </Form.Group>
		            <Form.Group controlId="fullName">
		                <Form.Label>
		                    {t('user.columns.fullname')}
		                </Form.Label>
		                <Form.Control type="input" placeholder={t('user.columns.fullname')} name="fullName" value={data.fullName || ''} onChange={handleChange}/>
		            </Form.Group>
		            <Form.Group controlId="roles">
		                <Form.Label>
		                    {t('user.columns.roles')}
		                </Form.Label>
		                <Select
		                    placeholder={t('user.select.placeholder')}
		                    isLoading={userRoles.length === 0}
		                    options={userRoles}
		                    value={data.userRoles}
		                    getOptionLabel={userRole => userRole.roleAuthority}
		                    getOptionValue={userRole => userRole.role}
		                    isMulti={true}
		                    closeMenuOnSelect={false}
		                    onChange={onRoleChange}
		                />
		            </Form.Group>
		            { !data.dateCreated &&
		                <Form.Group controlId="copyFrom">
		                    <Form.Label>
			                    {t('user.copyrolesfrom')}
			                </Form.Label>
			                <Select
			                    placeholder={t('user.chooseuser')}
			                    options={users}
			                    value={[]}
			                    getOptionLabel={user => user.username + ' (' + user.customerName + ')'}
			                    getOptionValue={user => user.id}
			                    isMulti={false}
			                    closeMenuOnSelect={true}
			                    onChange={handleUserChange}
			                />
		                </Form.Group>
		            }
		            <Form.Group controlId="userLicenses">
		                <Form.Label>
		                    {t('user.columns.licenses')}
		                </Form.Label>
		                <Select
		                    placeholder={t('user.columns.licenses')}
		                    isLoading={userLicenses.length === 0}
		                    options={filterUserLicenses()}
		                    value={data.userLicenses}
		                    getOptionLabel={userLicense => userLicense.name || userLicense.licenseCode}
		                    getOptionValue={userLicense => userLicense.license}
		                    isMulti={true}
		                    closeMenuOnSelect={false}
		                    onChange={onUserLicenseChange}
		                />
		            </Form.Group>
		        </Col>
		        <Col sm="6">
		            <Form.Group controlId="enabled">
		                <Form.Check type="checkbox" label={t('user.columns.enabled')} name="enabled" checked={data.enabled} onChange={handleChange} />
		            </Form.Group>
		            <Form.Group controlId="accountExpired">
		                <Form.Check type="checkbox" label={t('user.columns.accountexpired')} name="accountExpired" checked={data.accountExpired} onChange={handleChange} />
		            </Form.Group>
		            <Form.Group controlId="accountLocked">
		                <Form.Check type="checkbox" label={t('user.columns.accountlocked')} name="accountLocked" checked={data.accountLocked} onChange={handleChange}/>
		            </Form.Group>
		            <Form.Group controlId="passwordExpired">
		                <Form.Check type="checkbox" label={t('user.columns.passwordexpired')} name="passwordExpired" checked={data.passwordExpired} onChange={handleChange}/>
		            </Form.Group>
		            <Form.Group controlId="twoFactorAuthenticationType">
		                <Form.Label>
		                    {t('user.columns.twofactorauthenticationtype')}
		                </Form.Label>
		                <Form.Control required as="select" name="twoFactorAuthenticationType" value={data.twoFactorAuthenticationType} onChange={handleChange}>
		                    <option value="NONE">NONE</option>
		                    <option value="EMAIL">EMAIL</option>
		                    <option value="TOTP">TOTP</option>
		                </Form.Control>
		            </Form.Group>
			        <Form.Group controlId="params">
		                <Form.Label>
		                    {t('user.columns.params')}
		                </Form.Label>
			            { data.params && Object.keys(data.params).length > 0 &&
		                    <table>
		                        <thead>
		                            <tr>
		                                <th>
		                                    Nyckel
		                                </th>
		                                <th>
		                                    Värde
		                                </th>
		                                <th></th>
		                            </tr>
		                        </thead>
		                        <tbody>
		                            { Object.entries(data.params).map((entry, index) => {
		                                return <tr key={'entry-' + index}>
				                            <td>
				                                <Form.Control
				                                    required={true}
				                                    placeholder="Nyckel"
				                                    name="key"
				                                    value={entry[0]}
				                                    onChange={e => onChangeParamKey(e, entry[0])}
				                                />
				                            </td>
				                            <td>
				                                <Form.Control
				                                    placeholder="Värde"
				                                    name="key"
				                                    value={entry[1]}
				                                    onChange={e => onChangeParamValue(e, entry[0])}
				                                />
				                            </td>
				                            <td>
				                                <Button title="Ta bort" variant="outline-danger" size="sm" onClick={e => removeParam(entry[0])}>
													<FontAwesomeIcon icon={faTrash}/>
												</Button>
				                            </td>
				                        </tr>
		                            })}
		                        </tbody>
		                    </table>
		                }
		                <div>
		                    <Button title="Lägg till" variant="outline-primary" onClick={addParam}>
								Lägg till <FontAwesomeIcon icon={faPlus}/>
							</Button>
						</div>
		            </Form.Group>
	                <Dropdown>
                        <Dropdown.Toggle variant="primary" disabled={!data.username || !data.password || !data.email}>
                            Skicka mejl
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item href={getMailTo("SV")}>
                                SV
                            </Dropdown.Item>
                            <Dropdown.Item href={getMailTo("EN")}>
                                EN
                            </Dropdown.Item>
						</Dropdown.Menu>
                    </Dropdown>
		        </Col>
            </Row>
        </Form>
    )
}


export default UserForm